import { usePage } from "@inertiajs/react"
import { SubNav } from "@/components/SubNav"
import type { PageProps } from "@/types/inertia"

/**
 * The BUMP Training Tracker's tab strip.
 *
 * Summary is shown only to IUPAT staff. That is presentation, never access
 * control — BumpTraining::SummariesController includes RequiresIupat, so the
 * route refuses a DC user whether or not they can see the tab.
 *
 * Both tabs pass an explicit `active` predicate: "/bump_training" is a prefix of
 * "/bump_training/summary", so the default match would light Tracker on both.
 *
 * No OrgSwitcher in the right-hand slot. The tracker is personal, and the
 * summary is union-wide — neither changes with the organization being viewed.
 */
export function BumpTrainingSubNav() {
  const iupat = usePage<PageProps>().props.current_user?.iupat ?? false

  const items = [
    {
      href: "/bump_training",
      label: "Tracker",
      active: (url: string) =>
        url === "/bump_training" || url.startsWith("/bump_training?"),
    },
  ]

  if (iupat) {
    items.push({
      href: "/bump_training/summary",
      label: "Summary",
      active: (url: string) => url.startsWith("/bump_training/summary"),
    })
  }

  return <SubNav ariaLabel="BUMP Training Tracker sections" items={items} />
}
